import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { StudyMetaInfo } from '@/shared/config/types';

export const isSecondaryStudyMetaInfo =
  (studyID: string, type: StudyType) => (studyMetaInfo: StudyMetaInfo) =>
    studyMetaInfo.studyType === type && studyMetaInfo.ID !== studyID;
